import React, { useState } from 'react';
import { X, FolderOpen } from 'lucide-react';
import { motion } from 'framer-motion';
import { CategorySelectorAuto } from '../settings/CategorySelectorAuto';

interface CategorySearchModalProps {
  initialValue?: string;
  onSelect: (categoryYahoo: string) => void;
  onClose: () => void;
}

export function CategorySearchModal({ initialValue, onSelect, onClose }: CategorySearchModalProps) {
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const handleCategoryChange = (selected: any) => {
    setSelectedCategory(selected);
  };

  const handleConfirm = () => {
    if (selectedCategory) {
      onSelect(selectedCategory.value);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-lg max-w-2xl w-full mx-4 max-h-[90vh] flex flex-col"
      >
        <div className="p-4 border-b flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FolderOpen className="w-5 h-5 text-gray-600" />
            <h3 className="text-lg font-medium text-gray-900">カテゴリを選択</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <CategorySelectorAuto
            valueYahoo={initialValue}
            onChangeYahoo={handleCategoryChange}
          />
        </div>

        <div className="p-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            キャンセル
          </button>
          <button
            onClick={handleConfirm}
            disabled={!selectedCategory}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            選択
          </button>
        </div>
      </motion.div>
    </div>
  );
}